<template>
  <v-app>
    <Header
      v-if="is_show"
      :data="setting"
      :init_step_historys="step_historys"
      :init_step_history_index="step_history_index"
      :default_device_type="device_type"
    />
    <Container v-if="is_show" :data="setting" :step_historys="step_historys" :src="src" :vid="vid" />

    <Editor
      v-if="is_show"
      :init_step_historys="step_historys"
      :init_step_history_index="step_history_index"
      :vid="vid"
      :data="setting"
    />

    <v-dialog v-if="dialog_setting.is_show" v-model="dialog_setting.is_show" width="500">
      <v-card>
        <v-card-title>
          {{ dialog_setting.title }}
        </v-card-title>

        <v-card-text v-if="dialog_setting.mode === 'waitIframe'">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              {{ dialog_setting.text }}
            </v-col>
            <v-col cols="12">
              <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="pt-4">
          <v-alert
            v-if="dialog_setting.alert_type.is_show"
            dense
            :type="dialog_setting.alert_type.type"
            :color="dialog_setting.alert_type.color"
            :icon="dialog_setting.alert_type.color.icon"
            class="mb-0"
          >
            {{ dialog_setting.text }}
          </v-alert>
          <p v-if="dialog_setting.alert_type.is_show === false" class="mb-0">
            {{ dialog_setting.text }}
          </p>

          <div v-if="dialog_setting.html" v-html="dialog_setting.html"></div>

          <v-card v-if="dialog_setting.data">
            <v-data-table :headers="headers" :items="data" hide-default-footer :items-per-page="data.length">
            </v-data-table>
          </v-card>
        </v-card-text>
        <!-- 
                <v-card-text v-if="dialog_setting.mode === 'detectFail'">
                    <v-alert
                        color="orange"
                        type="warning"
                        icon="mdi-alert-outline"
                    >
                        {{dialog_setting.text}}
                    </v-alert>
                </v-card-text>

                <v-card-text v-if="dialog_setting.mode === 'saveConfig'">
                    {{dialog_setting.text}}
                </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            v-for="(btn, idx) in dialog_setting.btns"
            :key="idx"
            :color="btn.color"
            text
            @click="btn.callback(dialog_setting.data)"
          >
            {{ btn.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { apiGetOneSetting } from '@/api/urlview.js'
import Header from '@/views/OptimizePage/PagePlugin/PageEditor/Components/Header.vue'
import Container from '@/views/OptimizePage/PagePlugin/PageEditor/Components/Container.vue'
import Editor from '@/views/OptimizePage/PagePlugin/PageEditor/Components/Editor.vue'
import { eventBus } from '@/event_bus.js'
export default {
  name: 'OptimizePageEditorApp',
  components: {
    Header,
    Container,
    Editor,
  },
  data: function () {
    return {
      experience: null,
      view: null,
      view_data: null,
      src: null,
      is_show: false,
      is_install: false,
      dialog_setting: {
        is_show: false,
      },
      step_historys: [],
      step_history_index: -1,
      unique_history: {},
      device_type: {},
      device_type_mapper: {
        desktop: {
          id: 'desktop',
          icon: 'mdi-monitor',
          name: '桌機',
        },
        tablet: {
          id: 'tablet',
          icon: 'mdi-tablet',
          name: '平板',
        },
        mobile: {
          id: 'mobile',
          icon: 'mdi-cellphone',
          name: '手機',
        },
      },
      allow_plugin_types: ['online_user', 'sales_counter'],
      setting: null,
      vid: '',
    }
  },
  computed: {},
  created: async function () {
    eventBus.$on('open-dialog', this.openDialog)
  },
  destroyed: function () {
    eventBus.$off('open-dialog', this.openDialog)
  },
  mounted: async function () {
    // 清空前次紀錄
    // this.$store.commit('setIsShowSidebar', false)
    this.$store.commit('setDeviceType', 'desktop')

    let url_query = this.$route.query
    // if (!url_query.type && !this.allow_plugin_types.includes(url_query.type)) {
    //     this.$router.go(-1)
    //     return
    // }

    let data = null
    try {
      let result = await apiGetOneSetting(this.$route.params.org_id, this.$route.params.id)
      console.log('result:', result)
      data = result.data
      this.setting = data
      this.vid = `${this.$route.params.container_id}-${data.urlView.id}`

      const randomUUID = uuidv4()
      let url_src = decodeURIComponent(data.urlView.url)
      url_src = new URL(url_src)
      url_src.searchParams.append('opt99_edit', 'true')
      url_src.searchParams.append('uuid', randomUUID)
      url_src.searchParams.append('vid', this.vid)
      this.src = url_src.href

      if (this.device_type_mapper[url_query.device_type]) {
        this.device_type = this.device_type_mapper[url_query.device_type]
      } else {
        this.device_type = this.device_type_mapper['desktop']
      }
      console.log('device_type', this.device_type)
      this.$store.commit('setDeviceType', this.device_type.id)

      // 初始化歷史紀錄
      console.log('this.setting.urlView.add_column', this.setting.urlView.add_column)
      if (this.setting.urlView.add_column) {
        try {
          let add_column = JSON.parse(this.setting.urlView.add_column)
          if (add_column[this.device_type.id]) {
            this.step_historys = add_column[this.device_type.id]
            this.step_history_index = this.step_historys.length - 1
          }
        } catch (error) {
          console.log('loaded_error', error)
        }
      }
      this.is_show = true
      console.log('historysss', this.step_historys)
    } catch (error) {
      console.log(error)
      this.$root.vtoast.show({
        message: `取得設定檔失敗，原因: ${error}`,
      })
    }

    if (!this.setting) {
      this.$router.go(-1)
      return
    }

    // if (!this.is_install) {
    //     this.experience = await this.getExperience(url_query.experience_id, this.org_id)
    //     this.view = await this.getView(url_query.view_id, this.org_id)
    //     if (!this.experience || !this.view) {
    //         this.$router.go(-1)
    //         return
    //     }
    // }
    // this.view_data = JSON.parse(JSON.stringify(this.view))
    // this.view  = JSON.parse(JSON.stringify(this.view.view))

    // 初始化歷史紀錄
    // if (!this.is_install) {
    //     if (this.view && this.view.add_column){
    //         let add_column = JSON.parse(this.view.add_column)
    //         if (Array.isArray(add_column.history)) {
    //             this.step_historys = add_column.history
    //             this.step_history_index =  add_column.history.length - 1
    //         }
    //     }
    // }

    // console.log('APPPPPPP',this.view)
    // console.log('step_historys', this.step_historys)
    // console.log('step_idx', this.step_history_index)
    // console.log('view_data', this.view_data)
    // console.log('ab_test', this.view)
    // const randomUUID = uuidv4();
    // let url_src = ''

    // if (url_query.url) {
    //     url_src = url_query.url
    // }
    // else {
    //     url_src = decodeURIComponent(decodeURIComponent(this.experience.url))
    // }
    // console.log('url_src', url_src)
    // url_src = new URL(url_src)
    // url_src.searchParams.append('opt99_edit', 'true');
    // url_src.searchParams.append('uuid',randomUUID)
    // url_src.searchParams.append('vid', this.view.vid)

    // this.src = url_src.href

    // if (this.device_type_mapper[url_query.device_type]) {
    //     this.device_type = this.device_type_mapper[url_query.device_type]
    // }
    // else {
    //     this.device_type = this.device_type_mapper['desktop']
    // }
    // console.log('device_type', this.device_type)
    // this.$store.commit('setDeviceType', this.device_type.id)
    // this.is_show = true
  },
  methods: {
    openDialog: function (dialog_setting) {
      let that = this
      console.log('dialog_setting', dialog_setting)
      if (dialog_setting.is_show === false) {
        this.dialog_setting.is_show = false
        return
      }

      that.dialog_setting = dialog_setting

      if (dialog_setting.time) {
        setTimeout(function () {
          that.dialog_setting.is_show = false
        }, dialog_setting.time)
      }
    },
  },
}
</script>

<style></style>
